'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import * as T from 'prop-types';
import React, {Fragment} from 'react';
import {Button} from '../../../components/buttons/Button';
import {QuickStatusButton} from '../../../components/buttons/QuickStatusButton';
import {ProjectLayout} from '../../../components/views/ProjectLayout';
import {isButtonState} from '../../../core-utilities/enums/ButtonState';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {FileFulfillmentList} from '../FileFulfillmentList';
import {RequirementNavigationBar} from '../RequirementNavigationBar';
import {RequirementViewBanner} from '../RequirementViewBanner';


// TODO: setup drag-n-drop file support in list content area
// When hovering files, show an overlay that informs the user they can drop files to upload them there.
export function BaseRequirementViewFilesView(props) {
  const requirement = props.requirement;
  const uploadingStatus = props.uploadingStatus;
  const hasInProgress = get(uploadingStatus, 'hasInProgress', false);
  const hasPending = get(uploadingStatus, 'hasPending', false);
  const showRetryUploads = props.canRetryUploads && hasPending;

  return (
    <ProjectLayout
      className={classNames("RequirementViewFiles", props.className)}
      title={props.viewTitle}
      showBackButton={true}
      onGoBack={props.onGoBack}
      breadcrumbPath={props.breadcrumbPath}
      filterComponent={null}
      headerRightContent={(
        <Fragment>
          <QuickStatusButton
            className={classNames("RequirementViewFiles__quickButton", {
              'hide-elem': showRetryUploads,
            })}
            disabled={hasInProgress || hasPending}
            model={requirement}
            status={get(requirement, 'status')}
            validStatuses={get(requirement, 'validStatuses')}
          />
          {showRetryUploads ? (
            <Button
              className="RequirementViewFiles__retryButton"
              label={props.retryLabel}
              onClick={props.onRetryUploads}
            />
          ) : null}
          <Button
            className="RequirementViewFiles__headerButton"
            iconClass="context-icon"
            onClick={props.onClickOptions}
          />
        </Fragment>
      )}
      navBarContent={(
        <RequirementNavigationBar
          collection={props.collection}
        />
      )}
      bannerContent={(
        <RequirementViewBanner
          userId={props.userId}
          collection={props.collection}
          requirement={requirement}
          showQuickSubmit={props.showQuickSubmit}
          showQuickApprove={props.showQuickApprove}
          quickMode={props.quickMode}
          uploadingStatus={props.uploadingStatus}

          showCameraButton={props.showCameraButton}
          showVideoButton={props.showVideoButton}
          showUploadButton={props.showUploadButton}
          showIOSUpButton={props.showIOSUpButton}
          showDownloadButton={props.showDownloadButton}
          canRetryUploads={props.canRetryUploads}
          canAddFile={props.canAddFile}
          canDownloadFiles={props.canDownloadFiles}

          onClickEdit={props.onClickEdit}
          onSelectSubmit={props.onSelectSubmit}
          onSelectApprove={props.onSelectApprove}
          onToggleHeaderExpanded={props.onToggleHeaderExpanded}
          onOpenCamera={props.onOpenCamera}
          onOpenVideo={props.onOpenVideo}
          onOpenFilePicker={props.onOpenFilePicker}
          onOpenIOSFilePicker={props.onOpenIOSFilePicker}
          onDisabledAttempt={props.onDisabledAttempt}
          onDownloadAllFiles={props.onDownloadAllFiles}
          onRetryUploads={props.onRetryUploads}

          init={props.init}
          mode={props.mode}
          onLoadMore={props.onLoadMore}
        />
      )}
      mode={props.mode}
      onLoadMore={props.onLoadMore}

      useDnD={true}
      dropPanelClassName="RequirementViewFiles__dropPanel"
      isDraggingPanelClassName="RequirementViewFiles__dropPanel_isDragging"
      onDrop={props.onDropFile}
    >
      <FileFulfillmentList
        list={props.list}
        uploading={props.uploading}
        openingFileId={props.openingFileId}
        useScroll={false}
        mode={props.mode}
        onLoadMore={props.onLoadMore}
        userId={props.userId}
        parentId={props.parentId}
        collection={props.collection}
        requirement={requirement}

        onClickItem={props.onClickItem}
        onClickUpload={props.onClickUpload}
        onItemContextMenu={props.onItemContextMenu}

        init={props.init}
      />
    </ProjectLayout>
  );
}

BaseRequirementViewFilesView.propTypes = {
  className: T.string,
  userId: T.string.isRequired,
  requirement: T.object,
  openingFileId: T.string,
  showQuickSubmit: T.bool,
  showQuickApprove: T.bool,
  quickMode: isButtonState,
  uploadingStatus: T.any,
  showCameraButton: T.bool,
  showVideoButton: T.bool,
  showUploadButton: T.bool,
  showIOSUpButton: T.bool,
  showDownloadButton: T.bool,
  canAddFile: T.bool,
  canDownloadFiles: T.bool,
  canRetryUploads: T.bool,

  onClickOptions: T.func.isRequired,
  onClickEdit: T.func.isRequired,
  onToggleHeaderExpanded: T.func.isRequired,
  onOpenCamera: T.func.isRequired,
  onOpenVideo: T.func.isRequired,
  onOpenFilePicker: T.func.isRequired,
  onOpenIOSFilePicker: T.func.isRequired,
  onDisabledAttempt: T.func.isRequired,
  onDownloadAllFiles: T.func.isRequired,
  onDropFile: T.func.isRequired,
  onClickItem: T.func.isRequired,
  onItemContextMenu: T.func.isRequired,
  onRetryUploads: T.func,

  viewTitle: T.string,
  retryLabel: T.string,

  init: T.bool,
};

BaseRequirementViewFilesView.defaultProps = {
  init: true,
};

export const RequirementViewFilesView = I18nComponent(BaseRequirementViewFilesView, [
  {code: 'requirements.views.files.title', prop: 'viewTitle'},
  {code: 'requirements.files.context.retyuploads.label', prop: 'retryLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/requirements/components/RequirementViewFiles/RequirementViewFilesView.js